import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import {
  useNewResourceMutation,
  useGetResourceTypesQuery,
} from "../../services/appln";
import ErrorMsg from "../../components/ErrorMsg";
import { Autocomplete } from "@mui/material";

interface FormData {
  name: string;
  externalSerialNo: string;
  resourceTypeId: string;
}

interface Props {
  onSubmitHandler: (newObj: any) => void;
  onCancelHandler: () => void;
  state: boolean;
}

export default function NewResource(props: Props) {
  const [createResource, createResourceParams] = useNewResourceMutation();

  const iv: FormData = {
    name: "",
    externalSerialNo: "",
    resourceTypeId: "",
  };

  const resourceTypeData = useGetResourceTypesQuery(null);

  const resourceTypeMap = new Map<string, string>();
  resourceTypeData.data?.data.forEach((element: any) => {
    resourceTypeMap.set(element.name, element.id);
  });

  const onCancelHandlerWrapper = () => {
    createResourceParams.reset();
    props.onCancelHandler();
  };

  console.log("NewResource, createResourceParams", createResourceParams);
  React.useEffect(() => {
    if (createResourceParams.isSuccess) {
      props.onSubmitHandler(createResourceParams.data.id);
    }
  }, [createResourceParams]);

  return (
    <div>
      <Dialog
        open={props.state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">{strings.newResource}</DialogTitle>
        {createResourceParams.isError && (
          <ErrorMsg msg={strings.failedToCreateResource} />
        )}
        {createResourceParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.name) {
                errors.name = strings.nameMandatory;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              const valuesClone: any = { ...values };
              valuesClone["resourceTypeId"] = resourceTypeMap.get(
                values.resourceTypeId,
              )!;
              console.log(
                "NewResource, values after modification",
                valuesClone,
              );
              createResource(valuesClone);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="name"
                        name="name"
                        label={strings.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        margin="normal"
                        id="externalSerialNo"
                        name="externalSerialNo"
                        label={strings.extSerialNo}
                        value={values.externalSerialNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.externalSerialNo &&
                          Boolean(errors.externalSerialNo)
                        }
                        helperText={
                          touched.externalSerialNo && errors.externalSerialNo
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Autocomplete
                        fullWidth
                        disablePortal
                        id="resourceTypeId"
                        options={Array.from(resourceTypeMap.keys())}
                        renderInput={(params) => (
                          <TextField {...params} label={strings.resourceType} />
                        )}
                        onChange={(e, value: any) => {
                          setFieldValue("resourceTypeId", value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.create}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={onCancelHandlerWrapper}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
